<section id="hero-section" class="hero-banner">
    <div class="hero-images">
        <img id="hero-dog" class="hero-image-1 hero-dog" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-perro.webp" alt="" srcset="">
        <img class="hero-image-2" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-personas.webp" alt="" srcset="">
        <img class="hero-image-3" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-hombre.webp" alt="" srcset="">
        <div class="hero-logo">
            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-hero-logo-unipay.png" alt="" srcset="">
        </div>
        <div class="hero-bubbles">
            <img class="hero-bubble hero-bubble-1" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-2" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-1.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-3" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-2.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-4" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-3.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-5" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-2.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-6" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-1.svg" alt="" srcset="">
            <img class="hero-bubble hero-bubble-7" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-burbuja-3.svg" alt="" srcset="">
        </div>
    </div>
</section>

<div class="container">
    <section id="referidos" class="animate-section">
        <div class="referrals-container">
            <div class="referrals-content">
                <h2 class="referrals-title">
                    Llegó el momento de invitar hasta el contacto que olvidaste que tenías guardado.
                </h2>
                <div class="referrals-highlight">
                    <p class="parrafo1">Porque si los invitas a ser parte de Unipay</p>
                    <p class="highlight-amount parrafo2">¡TE PODRÁS LLEVAR HASTA $200.000!</p>
                </div>
                <p class="referrals-subtitle">
                    <b>Por cada contacto que abra su cuenta en Unipay te regalamos $10.000</b>
                    <br>¡Invítalos a todos y todas!
                </p>
            </div>
        </div>
        <div class="referrals-images">
            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-unipay-mano.webp" alt="Unipay App en smartphone" class="phone-image">
            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-bg-unipay-mano.svg" alt="" class="bg-decoration" aria-hidden="true">
        </div>
    </section>
    <section id="como-participar" class="animate-section">
        <div class="participation-card">
            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-unipay.webp" alt="Unipay Logo" class="unipay-logo mb-4" id="unipayLogo">

            <div class="participation-content">
                <h3 style="color:#53565a" class="text-center mb-4 mt-5">¿CÓMO PARTICIPAR?</h3>

                <div class="participation-steps">
                    <div class="participation-step">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-numero-uno.png" alt="1" class="step-number">
                        <div class="step-content">
                            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-people.svg" alt="" class="step-icon">
                            <div class="step-text">
                                <p>
                                    <b>Comparte tu código de referencia</b> (es tu rut sin puntos y sin código
                                    verificador),
                                    con
                                    tus amigos y con todos los que conozcas para así invitarlos a ser parte de
                                    Unipay.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="participation-step">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-numero-dos.png" alt="2" class="step-number">
                        <div class="step-content">
                            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-entry.svg" alt="" class="step-icon">
                            <div class="step-text">
                                <p>
                                    <b>Tus amigos deben ingresar tu código de referencia</b> en la casilla
                                    correspondiente al
                                    momento de su inscripción.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="participation-step">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-numero-tres.png" alt="3" class="step-number">
                        <div class="step-content">
                            <img src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-money.svg" alt="" class="step-icon">
                            <div class="step-text">
                                <p>
                                    <b>Recibe $10.000</b> en tu cuenta por cada referido que abra su cuenta Unipay.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


<section id="invita-aqui" class="text-center animate-section">
    <a rel="noopener" href="https://www.unipay.cl/autoapertura?utm_source=Digital&utm_medium=Referidos&utm_campaign=banner" target="_blank" class="btn btn-dark btn-lg">¡INVITA AQUÍ!</a>
    <div class="invita-aqui-content">
        <img class="segundo-plano" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-bg-invita-aqui-2.webp" alt="" srcset="">
        <img class="primer-plano" src="https://www.unipay.cl/api/descargaArchivo/web002-invitalos-bg-invita-aqui-1.webp" alt="" srcset="">
    </div>
</section>

<section class="faq-section mb-5 animate-section">
    <h3 id="faqTitle" class="text-center text-white">PREGUNTAS FRECUENTES</h3>

    <div class="accordion accordion-flush container" id="accordionFAQ">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button" type="button" aria-controls="collapseOne" aria-expanded="false" data-bs-toggle="collapse"
                data-bs-target="#collapseOne">
                    ¿CUÁL ES MI CÓDIGO DE REFERENCIA?
                </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionFAQ">
                <div class="accordion-body">
                    El código de referencia que deben ingresar tus referidos en el formulario es tu rut, sin puntos,
                    sin guión y sin dígito verificador. Solo recibirás el premio si este código está correctamente
                    ingresado.
                </div>
            </div>
        </div>

        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo">
                    ¿QUÉ GANO AL INVITARLOS A TODOS A PARTICIPAR?
                </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFAQ">
                <div class="accordion-body">
                    Ganarás $10.000 por cada amigo que finalice el proceso de contratación de Unipay. Para esto, tu
                    amigo debe ingresar tu código de referencia (que es tu rut, sin puntos, sin guión y sin dígito
                    verificador) y completar el formulario
                    <a rel="noopener" href="https://www.unipay.cl/autoapertura?utm_source=Digital&utm_medium=Referidos&utm_campaign=banner" target="_blank"
                        style="color: #fff">https://www.unipay.cl/autoatencion-ptoventa/validar-identidad</a>, y
                    listo!!!!
                </div>
            </div>
        </div>

        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree">
                    ¿CUÁNDO Y CÓMO RECIBIRÉ MI PREMIO?
                </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFAQ">
                <div class="accordion-body">
                    El premio lo recibirás en la siguiente o subsiguiente facturación luego que tu amigo haya
                    finalizado correctamente el proceso de activación de su cuenta Unipay. El premio lo recibirás
                    como abono en tu cuenta Unipay y no es intercambiable por dinero en efectivo. Entonces puedes
                    usar este premio para comprar en supermercados Unimarc, Mayorista 10, Alvi, Super 10, Unimarc.cl
                    o para pagar tus cuentas en unired.cl.
                </div>
            </div>
        </div>

        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour">
                    ¿TODOS, TODOS PARTICIPAN?
                </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionFAQ">
                <div class="accordion-body">
                    Solo participan clientes titulares de una cuenta Unipay, pero pueden invitar a todos, todos a
                    participar. El premio solo lo recibirán clientes titulares de una cuenta Unipay que se encuentre
                    vigente.
                </div>
            </div>
        </div>
    </div>
</section>

<div class="text-center mb-5 bg-custom">
    <a href="https://www.unipay.cl/api/descargaArchivo/Bases_referidos.pdf" rel="noopener" target="_blank" class="btn btn-bases">
        <span>Revisa las bases aquí</span>
    </a>
</div>


